module.exports = __webpack_public_path__ + "assets/90b5c959d21b6ac61bd7ac494928c7bc.png";